import React from 'react';

import styles from './loader.module.scss';

function FixedLoader() {
  return <div className={styles.fixedLoader} />;
}

export default FixedLoader;
